import React, {useRef, useState, useEffect, useCallback} from 'react';
import {motion, useCycle} from "framer-motion";
import {useDimensions} from "./use-dimensions";
import {MenuToggle} from "./MenuToggle";
import Navigation from "./Navigation";
import styled from "styled-components"
import {PRIMARY_COLOR} from "../../constants/COLORS";

const StyledMotionNav = styled(motion.nav)`
  z-index: 99;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: 100vw;
  max-width: 400px;
  min-height: 100vh;
  box-sizing: border-box;
  font-family: Quicksand, sans-serif;
          pointer-events: none !important;

  
  &.open{
    overflow-y: auto;
    pointer-events: auto !important;
  }
  
  @media only screen and (max-width: 700px){
  max-width: none;
  }
  
  
  .background {
  

      position: fixed;
      top: 0;
      left: 0;
      bottom: 0;
      width: 100vw;
      max-width: 400px;
      height: 100vh;
      background: ${PRIMARY_COLOR};
      box-shadow: 5px 5px 15px 5px rgba(0, 0, 0, 0.15);
      @media only screen and (max-width: 700px){
        max-width: none;
      }

  }

button {
   box-shadow: ${props => props.open ? '' : '5px 5px 15px 5px rgba(0, 0, 0, 0.15)'};
   transition-duration: ${props => props.open ? '0.1s' : '0.5s'};
   transition-delay: ${props => props.open ? '0.1s' : '0.8s'};
  pointer-events: auto;
  outline: none;
  border: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  cursor: pointer;
  position: absolute;
  top: 19px;
  left: 15px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: transparent;
  

}
@media only screen and (max-width: 600px){
    button{
    box-shadow: none;
    }
 }
`

const sidebar = {
    open: (height = 1000) => ({
        clipPath: `circle(${height * 2 + 200}px at 40px 40px)`,
        transition: {
            type: "spring",
            stiffness: 20,
            restDelta: 2
        }
    }),
    closed: {
        clipPath: "circle(30px at 40px 40px)",
        transition: {
            delay: 0.5,
            type: "spring",
            stiffness: 400,
            damping: 40
        },
    }
};

function getWindowDimensions() {
    const {innerWidth: width, innerHeight: height} = window;
    return {
        width,
        height
    };
}

export const NavbarComponent = () => {

    const [isOpen, toggleOpen] = useCycle(false, true);
    const [showToggleButton, setToggleButtonVisibility] = useCycle(true, false)
    const containerRef = useRef(null);
    const {height} = useDimensions(containerRef);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const closeNavCB = useCallback(() => {
        if (window.innerWidth < 1250) {
            toggleOpen(false)
        }
    })
    useEffect(() => {
        function handleResize() {
            setWindowDimensions(getWindowDimensions())
        }

        function handleLinks() {
            document.querySelectorAll('.ant-menu-item a').forEach(item => {
                item.addEventListener('click', closeNavCB)
            })
        }

        function removeHandleLinks() {
            document.querySelectorAll('.ant-menu-item a').forEach(item => {
                item.removeEventListener('click', closeNavCB)
            })
        }

        handleLinks()
        window.addEventListener('resize', handleResize)
        return () => {
            removeHandleLinks()
            window.removeEventListener('resize', handleResize)
        }
    }, [])
    useEffect(() => {
        if (windowDimensions.width >= 1250 && !isOpen) {
            toggleOpen(true)
            if (showToggleButton) {
                setToggleButtonVisibility(false)
            }
        }
        if (windowDimensions.width < 1250 && isOpen) {
            toggleOpen(false)
            if (!showToggleButton) {
                setToggleButtonVisibility(true)
            }

        }
    }, [windowDimensions])

    return (
        <StyledMotionNav
            initial={false}
            animate={isOpen ? "open" : "closed"}
            custom={height}
            ref={containerRef}
            open={isOpen}
            className={isOpen ? 'open' : null}
        >
            <motion.div className="background" variants={sidebar}/>
            <Navigation open={isOpen}/>
            <MenuToggle toggle={() => toggleOpen()} showToggleButton={showToggleButton}/>
        </StyledMotionNav>
    );
};
